import { createAction, props } from '@ngrx/store';
import { Theme } from '../../../core/models/theme.model';

export const loadConfig = createAction('[Config] Load Config');
export const loadConfigSuccess = createAction(
  '[Config] Load Config Success',
  props<{ theme: Theme }>()
);
export const updateConfig = createAction(
  '[Config] Update Config',
  props<{ theme: Theme }>()
);

// AM STATUS

export const loadWFStatus = createAction(
  '[WokFlowStatus] Load Workflow Status'
);
export const loadWFStatusSuccess = createAction(
  '[WokFlowStatus] Load Workflow Status Success',
  props<{ states: any }>()
);
